import { motion } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faUserGraduate } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faHeartRegular, faBookmark as faBookmarkRegular } from "@fortawesome/free-regular-svg-icons";
import { faHeart as faHeartSolid, faBookmark as faBookmarkSolid } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { FaStar } from "react-icons/fa";
import api from "../../services/axiosInstance";
import * as FaIcons from "react-icons/fa";
 
const CourseCard = ({ openRatingModal,
  course,
  level,
  isLiked,
  isSaved,
  onLike,
  onSave,
  onRegister }) => {
  const navigate = useNavigate();  
  console.log("Rendering CourseCard for course:", course);
const [profRatingModal, setProfRatingModal] = useState({
  isOpen: false,
  profId: null,
  onSubmitted: null,
});
const isImageIcon = (icon) => {
  if (typeof icon !== "string") return false;

  return (
    icon.startsWith("http") ||icon.startsWith("https") ||
    icon.startsWith("/") ||
    icon.endsWith(".png") ||
    icon.endsWith(".jpg") ||
    icon.endsWith(".jpeg") ||
    icon.endsWith(".svg")
  );
};


// Get React Icon component dynamically
const getIconComponent = (iconName) => {
  if (!iconName) return null;
  return FaIcons[iconName] || null;
};
useEffect(() => {
  if (!course?.instructor?.id) return;

  const fetchProfRating = async () => {
    try {
      const { data } = await api.get(`/users/${course.instructor.id}`);
      if (data.success) {
        setProfRatings(prev => ({ 
          ...prev, 
          [course.instructor.id]: data.data 
        }));
      }
    } catch (err) {
      console.error(`Error fetching rating for professor ${course.instructor.id}:`, err);
    }
  };

  fetchProfRating();
}, [course?.instructor?.id]); // Run when instructor id changes
const [profRatings, setProfRatings] = useState({});
  const fetchProfRating = async (profId) => {
  try {
    const { data } = await api.get(`/users/${profId}`);
    if (data.success) {
      setProfRatings((prev) => ({ ...prev, [profId]: data.data }));
    }
  } catch (err) {
    console.error("Error fetching prof rating", err);
  } 
};
  return (
    <motion.div
      key={course.id}
      initial={{ opacity: 0, y: 60, scale: 0.95 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once: true }}
      transition={{ 
        delay: course.index * 0.15,
        type: "spring",
        stiffness: 100,
        damping: 15
      }}
      whileHover={{ 
        y: -12,
        transition: { type: "spring", stiffness: 300 }
      }}
      className="group relative h-full flex"
    >
      {/* Card container with gradient border */}
      <div className={`relative flex flex-col h-full w-full rounded-2xl ${level.bg} p-0.5`}>
        <div className="relative flex flex-col h-full bg-white rounded-[1.2rem] overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
          {/* Corner accent */}
          <div className={`absolute top-0 right-0 w-20 h-20 bg-gradient-to-bl ${level.color} opacity-10 rounded-bl-full`} />

          {/* Header with level indicator */}
          <div className="relative px-5 pt-5">
            <div className="flex items-start justify-between mb-4">
              <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full ${level.badge} backdrop-blur-sm border border-white/50`}>
                <FontAwesomeIcon icon={level.icon} className="text-xs" />
                <span className="text-xs font-semibold">{course.niveau}</span>
              </div>
              
              <div className="flex items-center gap-2">
               <motion.button
  whileTap={{ scale: 0.9 }}
  onClick={() => onLike(course.id)}
  className={`w-8 h-8 rounded-lg flex items-center justify-center backdrop-blur-sm ${
    isLiked
      ? "bg-red-50 border border-red-100"
      : "bg-white/80 border border-gray-100"
  }`}
>
  {isLiked ? (
    <FaIcons.FaHeart className="text-red-500 scale-110" />
  ) : (
    <FaIcons.FaRegHeart className="text-gray-400 hover:text-red-500" />
  )}
</motion.button>


                
              <motion.button
  whileTap={{ scale: 0.9 }}
  onClick={() => onSave(course.id)}
  className={`w-8 h-8 rounded-lg flex items-center justify-center backdrop-blur-sm ${
    isSaved
      ? "bg-emerald-50 border border-emerald-100"
      : "bg-white/80 border border-gray-100"
  }`}
>
  {isSaved ? (
    <FaIcons.FaBookmark className="text-emerald-600 scale-110" />
  ) : (
    <FaIcons.FaRegBookmark className="text-gray-400 hover:text-emerald-600" />
  )}
</motion.button>

 
              </div>
            </div>

            {/* Course icon with floating effect */}
             <motion.div 
              whileHover={{ scale: 1.05 }}
              className={`relative w-14 h-14 rounded-xl mb-4 overflow-hidden bg-gradient-to-br ${level.color} p-0.5 flex items-center justify-center`}
            >
              <div className="w-full h-full bg-white rounded-xl flex items-center justify-center overflow-hidden">
            
                {/* IMAGE ICON */}
                {isImageIcon(course.icon) && (
                  <img
                    src={
                      course.icon.startsWith("http") || course.icon.startsWith("https")
                        ? course.icon
                        : `${process.env.REACT_APP_LOCAL_API_URL}${course.icon}`
                    }
                    alt="course icon"
                    className="w-8 h-8 object-contain"
                  />
                )}
            
                {/* REACT ICON */}
                {!isImageIcon(course.icon) && getIconComponent(course.icon) && (
                  <div
                    className={`text-2xl bg-gradient-to-br ${level.color} bg-clip-text `}
                  >
                    {React.createElement(getIconComponent(course.icon))}
                  </div>
                )}
            
                {/* FALLBACK */}
                {!course.icon && (
                  <div
                    className={`text-xl font-bold bg-gradient-to-br ${level.color} bg-clip-text text-transparent`}
                  >
                    {course.title.charAt(0)}
                  </div>
                )}
            
              </div>
            </motion.div>

            {/* Course title with gradient */}
            <h3 className="text-lg font-bold text-gray-900 mb-2 leading-tight line-clamp-2">
              {course.name} 
            </h3>

            {/* Course description */}
            <p className="text-sm text-gray-600 mb-4 leading-relaxed line-clamp-2">
              {course.description}
            </p>
          </div>

          {/* Flexible spacer */}
          <div className="flex-grow"></div>

          {/* Instructor section */}
          <div className="px-5 mb-4">
            <div className="flex items-center gap-2 p-3 rounded-xl backdrop-blur-sm border border-gray-100">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-gray-100 to-gray-200 backdrop-blur-sm flex items-center justify-center shrink-0">
                <FontAwesomeIcon icon={faUserGraduate} className="text-gray-600 text-xs" />
              </div>
              <div className="min-w-0">
                <p className="text-xs text-gray-500">Instructor</p>
                <p className="font-semibold text-gray-900 text-sm truncate">{course.instructor.name}</p>
              </div>
            </div>
          </div>

          {/* Footer with buttons */}
          <div className="px-5 pb-4 pt-3 border-t border-gray-100 bg-white">
            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
              <div className="w-full sm:w-auto">
                <p className="text-xs text-gray-500 mb-0.5">Prix</p>
                <div className="flex items-baseline gap-1">
                  <span className="text-lg font-bold text-gray-900">{course.price}</span>
                </div>
              </div>
              
              <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }} 
                  onClick={() => navigate(`/courses/${course.id}`)}
                  className="px-4 py-2.5 rounded-lg border border-gray-200 text-xs font-semibold text-gray-700 hover:border-gray-300 hover:bg-gray-50 transition-all flex items-center justify-center gap-1.5 w-full sm:w-auto"
                >
                  Voir détails
                  <FontAwesomeIcon icon={faArrowRight} className="text-[10px]" />
                </motion.button>
                
                <motion.button
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  onClick={() => onRegister(course.name, course.id)}
                  className="px-4 py-2.5 rounded-lg bg-emerald-400 text-white text-xs font-semibold hover:shadow-lg transition-all shadow-sm hover:shadow-emerald-200 flex items-center justify-center gap-1.5 w-full sm:w-auto"
                >
                  <FontAwesomeIcon icon={faUserGraduate} className="text-[10px]" />
                  S'inscrire
                  <FontAwesomeIcon icon={faArrowRight} className="text-[10px]" />
                </motion.button>
              </div> 
            </div>
          </div>
          {/* //rating */}
{course.instructor.id && (
  <div className="flex pl-3 pb-3 items-center gap-2">
    <div className="flex items-center gap-1">
      {Array.from({ length: 5 }, (_, i) => (
        <FaStar
          key={i} 
          size={14}
          className={`${
            i < (profRatings[course.instructor.id]?.average_rating || 0)
              ? "text-yellow-400"
              : "text-gray-300"
          }`}
        />
      ))}
      <span className="text-xs text-gray-500 ml-1">
        ({profRatings[course.instructor.id]?.total_ratings || 0})
      </span>
    </div>
    
    <button
      onClick={() =>
        openRatingModal(course.instructor.id, () =>
          fetchProfRating(course.instructor.id)
        )
      }
      className="text-xs text-blue-600 hover:underline"
    >
      Rate
    </button>
  </div>
)}

          {/* Hover shine effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-1000 pointer-events-none" />
        </div>
      </div>
      
    </motion.div>
    
  );
};

export default CourseCard;